{
  "data": [
    {
      "lang": "en-GB",
      "Title": "Analytics Cookie Consent",
      "Message": "This website uses cookies. Some cookies are necessary to enable basic website functions. Other cookies are optional and cookies may be placed on your device to improve your experience, collect statistics and optimize site functionality. To accept all optional cookies, click “Accept”; to refuse the use of all optional cookies, click “Reject”. You will be able to change your preferences at any time. You can learn more about our practices by reading our Cookie Policy.",
      "BtnAccept": "Accept",
      "BtnReject": "Reject",
      "Manage": "Manage Cookie",
      "AnalyticCookies": "Analytics cookie",
      "CookiePolicy": "Cookie Policy",
      "CookieConsent": "Cookie consent"
    },
    {
      "lang": "th-TH",
      "Title": "การยินยอมคุกกี้วิเคราะห์",
      "Message": "เว็บไซต์นี้ใช้คุกกี้ คุกกี้บางตัวจำเป็นเพื่อเปิดใช้งานฟังก์ชันพื้นฐานของเว็บไซต์ คุกกี้อื่นๆ เป็นทางเลือกและอาจถูกวางบนอุปกรณ์ของคุณเพื่อปรับปรุงประสบการณ์ของคุณ รวบรวมสถิติ และเพิ่มประสิทธิภาพการทำงานของเว็บไซต์ หากต้องการยอมรับคุกกี้ทั้งหมด ให้คลิก \"ยอมรับ\"; หากต้องการปฏิเสธการใช้คุกกี้ทั้งหมด ให้คลิก \"ปฏิเสธ\" คุณสามารถเปลี่ยนการตั้งค่าของคุณได้ตลอดเวลา คุณสามารถเรียนรู้เพิ่มเติมเกี่ยวกับแนวทางปฏิบัติของเราได้โดยอ่านนโยบายคุกกี้ของเรา",
      "BtnAccept": "ยอมรับ",
      "BtnReject": "ปฏิเสธ",
      "Manage": "จัดการคุกกี้",
      "AnalyticCookies": "คุกกี้วิเคราะห์",
      "CookiePolicy": "นโยบายคุกกี้",
      "CookieConsent": "การยินยอมคุกกี้"
    },
    {
      "lang": "zh-CN",
      "Title": "分析Cookie同意",
      "Message": "本网站使用cookies。某些cookies是启用基本网站功能所必需的。其他cookies是可选的，可以放置在您的设备上以改善您的体验，收集统计数据并优化网站功能。要接受所有可选cookies，请点击“接受”；要拒绝使用所有可选cookies，请点击“拒绝”。您可以随时更改您的偏好。您可以通过阅读我们的Cookie政策了解更多关于我们的做法。",
      "BtnAccept": "接受",
      "BtnReject": "拒绝",
      "Manage": "管理Cookie",
      "AnalyticCookies": "分析Cookie",
      "CookiePolicy": "Cookie政策",
      "CookieConsent": "Cookie同意"
    },
    {
      "lang": "tr-TR",
      "Title": "Analitik Çerez Onayı",
      "Message": "Bu web sitesi çerezleri kullanır. Bazı çerezler temel web sitesi işlevlerini etkinleştirmek için gereklidir. Diğer çerezler isteğe bağlıdır ve deneyiminizi geliştirmek, istatistik toplamak ve site işlevselliğini optimize etmek için cihazınıza yerleştirilebilir. Tüm isteğe bağlı çerezleri kabul etmek için \"Kabul Et\"e tıklayın; tüm isteğe bağlı çerezlerin kullanımını reddetmek için \"Reddet\"e tıklayın. Tercihlerinizi istediğiniz zaman değiştirebilirsiniz. Uygulamalarımız hakkında daha fazla bilgi edinmek için Çerez Politikamızı okuyabilirsiniz.",
      "BtnAccept": "Kabul Et",
      "BtnReject": "Reddet",
      "Manage": "Çerezi Yönet",
      "AnalyticCookies": "Analitik Çerez",
      "CookiePolicy": "Çerez Politikası",
      "CookieConsent": "Çerez Onayı"
    },
    {
      "lang": "fr-FR",
      "Title": "Consentement aux cookies analytiques",
      "Message": "Ce site utilise des cookies. Certains cookies sont nécessaires pour activer les fonctions de base du site. D'autres cookies sont facultatifs et peuvent être placés sur votre appareil pour améliorer votre expérience, collecter des statistiques et optimiser la fonctionnalité du site. Pour accepter tous les cookies facultatifs, cliquez sur \"Accepter\"; pour refuser l'utilisation de tous les cookies facultatifs, cliquez sur \"Refuser\". Vous pourrez modifier vos préférences à tout moment. Vous pouvez en savoir plus sur nos pratiques en lisant notre Politique de cookies.",
      "BtnAccept": "Accepter",
      "BtnReject": "Refuser",
      "Manage": "Gérer les cookies",
      "AnalyticCookies": "Cookie analytique",
      "CookiePolicy": "Politique de cookies",
      "CookieConsent": "Consentement aux cookies"
    },
    {
      "lang": "it-IT",
      "Title": "Consenso sui cookie analitici",
      "Message": "Questo sito web utilizza i cookie. Alcuni cookie sono necessari per abilitare le funzioni di base del sito web. Altri cookie sono opzionali e possono essere posizionati sul tuo dispositivo per migliorare la tua esperienza, raccogliere statistiche e ottimizzare la funzionalità del sito. Per accettare tutti i cookie opzionali, clicca su \"Accetta\"; per rifiutare l'uso di tutti i cookie opzionali, clicca su \"Rifiuta\". Potrai cambiare le tue preferenze in qualsiasi momento. Puoi saperne di più sulle nostre pratiche leggendo la nostra Politica sui cookie.",
      "BtnAccept": "Accetta",
      "BtnReject": "Rifiuta",
      "Manage": "Gestisci i cookie",
      "AnalyticCookies": "Cookie analitici",
      "CookiePolicy": "Politica sui cookie",
      "CookieConsent": "Consenso sui cookie"
    },
    {
      "lang": "de-DE",
      "Title": "Analyse-Cookie-Zustimmung",
      "Message": "Diese Website verwendet Cookies. Einige Cookies sind notwendig, um grundlegende Funktionen der Website zu ermöglichen. Andere Cookies sind optional und können auf Ihrem Gerät platziert werden, um Ihre Erfahrung zu verbessern, Statistiken zu sammeln und die Funktionalität der Website zu optimieren. Um alle optionalen Cookies zu akzeptieren, klicken Sie auf \"Akzeptieren\"; um die Verwendung aller optionalen Cookies abzulehnen, klicken Sie auf \"Ablehnen\". Sie können Ihre Präferenzen jederzeit ändern. Sie können mehr über unsere Praktiken erfahren, indem Sie unsere Cookie-Richtlinie lesen.",
      "BtnAccept": "Akzeptieren",
      "BtnReject": "Ablehnen",
      "Manage": "Cookie verwalten",
      "AnalyticCookies": "Analyse-Cookie",
      "CookiePolicy": "Cookie-Richtlinie",
      "CookieConsent": "Cookie-Zustimmung"
    },
    {
      "lang": "es-ES",
      "Title": "Consentimiento de cookies analíticas",
      "Message": "Este sitio web utiliza cookies. Algunas cookies son necesarias para habilitar funciones básicas del sitio web. Otras cookies son opcionales y pueden colocarse en su dispositivo para mejorar su experiencia, recopilar estadísticas y optimizar la funcionalidad del sitio. Para aceptar todas las cookies opcionales, haga clic en \"Aceptar\"; para rechazar el uso de todas las cookies opcionales, haga clic en \"Rechazar\". Podrá cambiar sus preferencias en cualquier momento. Puede obtener más información sobre nuestras prácticas leyendo nuestra Política de Cookies.",
      "BtnAccept": "Aceptar",
      "BtnReject": "Rechazar",
      "Manage": "Gestionar cookies",
      "AnalyticCookies": "Cookie analíticas",
      "CookiePolicy": "Política de cookies",
      "CookieConsent": "Consentimiento de cookies"
    },
    {
      "lang": "pl-PL",
      "Title": "Zgoda na pliki cookie analityczne",
      "Message": "Ta strona używa plików cookie. Niektóre pliki cookie są niezbędne do włączenia podstawowych funkcji witryny. Inne pliki cookie są opcjonalne i mogą być umieszczone na Twoim urządzeniu w celu poprawy Twojego doświadczenia, zbierania statystyk i optymalizacji funkcjonalności witryny. Aby zaakceptować wszystkie opcjonalne pliki cookie, kliknij „Akceptuj”; aby odmówić użycia wszystkich opcjonalnych plików cookie, kliknij „Odrzuć”. W każdej chwili możesz zmienić swoje preferencje. Możesz dowiedzieć się więcej o naszych praktykach, czytając naszą Politykę plików cookie.",
      "BtnAccept": "Akceptuj",
      "BtnReject": "Odrzuć",
      "Manage": "Zarządzaj plikami cookie",
      "AnalyticCookies": "Pliki cookie analityczne",
      "CookiePolicy": "Polityka plików cookie",
      "CookieConsent": "Zgoda na pliki cookie"
    },
    {
      "lang": "nl-NL",
      "Title": "Toestemming voor analytische cookies",
      "Message": "Deze website maakt gebruik van cookies. Sommige cookies zijn nodig om basisfuncties van de website mogelijk te maken. Andere cookies zijn optioneel en kunnen op uw apparaat worden geplaatst om uw ervaring te verbeteren, statistieken te verzamelen en de functionaliteit van de site te optimaliseren. Om alle optionele cookies te accepteren, klikt u op \"Accepteren\"; om het gebruik van alle optionele cookies te weigeren, klikt u op \"Weigeren\". U kunt uw voorkeuren op elk moment wijzigen. U kunt meer te weten komen over onze praktijken door ons Cookiebeleid te lezen.",
      "BtnAccept": "Accepteren",
      "BtnReject": "Weigeren",
      "Manage": "Cookie beheren",
      "AnalyticCookies": "Analytische cookies",
      "CookiePolicy": "Cookiebeleid",
      "CookieConsent": "Toestemming voor cookies"
    },
    {
      "lang": "da-DK",
      "Title": "Samtykke til analytiske cookies",
      "Message": "Denne hjemmeside bruger cookies. Nogle cookies er nødvendige for at aktivere grundlæggende funktioner på hjemmesiden. Andre cookies er valgfrie og kan placeres på din enhed for at forbedre din oplevelse, indsamle statistik og optimere webstedets funktionalitet. For at acceptere alle valgfrie cookies skal du klikke på \"Accepter\"; for at afvise brugen af alle valgfrie cookies skal du klikke på \"Afvis\". Du vil kunne ændre dine præferencer når som helst. Du kan lære mere om vores praksis ved at læse vores Cookiepolitik.",
      "BtnAccept": "Accepter",
      "BtnReject": "Afvis",
      "Manage": "Administrer cookies",
      "AnalyticCookies": "Analytiske cookies",
      "CookiePolicy": "Cookiepolitik",
      "CookieConsent": "Samtykke til cookies"
    },
    {
      "lang": "sv-SE",
      "Title": "Samtycke till analyscookies",
      "Message": "Denna webbplats använder cookies. Vissa cookies är nödvändiga för att aktivera grundläggande webbplatsfunktioner. Andra cookies är valfria och kan placeras på din enhet för att förbättra din upplevelse, samla in statistik och optimera webbplatsens funktionalitet. För att acceptera alla valfria cookies, klicka på \"Acceptera\"; för att vägra användningen av alla valfria cookies, klicka på \"Avvisa\". Du kommer att kunna ändra dina preferenser när som helst. Du kan lära dig mer om våra metoder genom att läsa vår Cookiepolicy.",
      "BtnAccept": "Acceptera",
      "BtnReject": "Avvisa",
      "Manage": "Hantera cookies",
      "AnalyticCookies": "Analyscookies",
      "CookiePolicy": "Cookiepolicy",
      "CookieConsent": "Samtycke till cookies"
    },
    {
      "lang": "en-US",
      "Title": "Analytics Cookie Consent",
      "Message": "This website uses cookies. Some cookies are necessary to enable basic website functions. Other cookies are optional and cookies may be placed on your device to improve your experience, collect statistics and optimize site functionality. To accept all optional cookies, click “Accept”; to refuse the use of all optional cookies, click “Reject”. You will be able to change your preferences at any time. You can learn more about our practices by reading our Cookie Policy.",
      "BtnAccept": "Accept",
      "BtnReject": "Reject",
      "Manage": "Manage Cookie",
      "AnalyticCookies": "Analytics cookie",
      "CookiePolicy": "Cookie Policy",
      "CookieConsent": "Cookie consent"
    },
    {
      "lang": "en-AU",
      "Title": "Analytics Cookie Consent",
      "Message": "This website uses cookies. Some cookies are necessary to enable basic website functions. Other cookies are optional and cookies may be placed on your device to improve your experience, collect statistics and optimize site functionality. To accept all optional cookies, click “Accept”; to refuse the use of all optional cookies, click “Reject”. You will be able to change your preferences at any time. You can learn more about our practices by reading our Cookie Policy.",
      "BtnAccept": "Accept",
      "BtnReject": "Reject",
      "Manage": "Manage Cookie",
      "AnalyticCookies": "Analytics cookie",
      "CookiePolicy": "Cookie Policy",
      "CookieConsent": "Cookie consent"
    }
  ]
}